import React, { useState } from 'react';
import LoadingSpinner from './LoadingSpinner';

interface ImageWithLoadingProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

const ImageWithLoading: React.FC<ImageWithLoadingProps> = ({ src, alt, className, style }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div style={{ position: 'relative', width: '100%', minHeight: isLoading ? '200px' : 'auto' }} className={`bg-light ${isLoading ? 'border rounded' : ''} d-flex align-items-center justify-content-center`}>
      {isLoading && (
        <div 
          className="d-flex align-items-center justify-content-center"
          style={{ 
            position: 'absolute', 
            inset: 0, 
            zIndex: 1
          }}
        >
          <LoadingSpinner />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        style={{ 
          ...style, 
          opacity: isLoading ? 0 : 1, 
          transition: 'opacity 0.2s ease-in-out'
        }}
        onLoad={() => setIsLoading(false)}
        onError={() => setIsLoading(false)}
      />
    </div>
  );
};

export default ImageWithLoading;
